import React, { memo, MouseEvent } from 'react';
import { useMergedClassNames } from '../../../../utils/HTMLutils';
import './CalendarChip.scss';
const rootClassName = 'calendar-chip';

export interface CalendarChipProps {
  color?: string;
  borderStyle?: 'solid' | 'dashed';
  num: number;
  onClick: (evt: MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}

function CalendarChip(props: CalendarChipProps) {
  return (
    <button
      className={useMergedClassNames([rootClassName, 'nunito'])}
      onClick={props.onClick}
      disabled={props.disabled}
      style={{ borderStyle: props.borderStyle, color: props.color }}
    >
      +{props.num}
    </button>
  );
}

CalendarChip.defaultProps = {
  color: '#3fa110',
  borderStyle: 'solid',
} as Partial<CalendarChipProps>;
export default memo(CalendarChip);
